import { useTranslation } from 'react-i18next';
import { Play } from 'lucide-react';
import Button from '../ui/Button';

/**
 * The one primary action on a report screen: turn the filters into figures.
 *
 * Labelled by what it does ("Run report"), not by the page it sits on, and it keeps its own label
 * while loading so the button does not change width mid-click.
 */

export interface RunButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  /** Overrides the default "Run report" label. */
  label?: string;
  className?: string;
  testId?: string;
}

export function RunButton({
  onClick,
  loading = false,
  disabled = false,
  label,
  className,
  testId,
}: RunButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      variant="default"
      size="sm"
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      className={className}
      data-testid={testId ?? 'report-run'}
    >
      {!loading && <Play className="me-2 h-4 w-4 shrink-0" aria-hidden="true" />}
      {loading ? t('reports.running') : (label ?? t('reports.run'))}
    </Button>
  );
}

export default RunButton;
